import { DataFieldType } from '~/enums/DataFieldType';
import { pilot } from '~/services/serviceInstances';
import { FolderTree } from '~/types/FolderTree';
import { PilotId } from '~/types/PilotId';

export type SearchableFieldId = string;

export type ClauseSuggestions = {
  suggestions: string[];
};

export type PilotField = {
  // values - deprecated, field values should be retrieved from the getFieldValues api endpoint
  id: SearchableFieldId | PilotId;
  /** Evisearch filter id for Unified Fields; null on legacy fields, which Evisearch addresses by `DYN_<id>`. */
  uf_field_id?: string | null;
  type: DataFieldType;
  chained_fields: SearchableFieldId[];
  name: string;
  label: string;
  is_pinned: boolean;
  groupId?: string;
  edit_type?: DataFieldType;
  help_text?: string;
};
export type PilotFieldSection = {
  title: string;
  fields: PilotField[];
};
export type AlertSectionsResponse = {
  sections: PilotFieldSection[];
};

export const getAlertSections = (): Promise<AlertSectionsResponse> =>
  pilot.get('/alert/sections/');
export const getFolderTree = (): Promise<FolderTree> => pilot.get('/path/');
